import React, {
    useContext, useEffect, useRef, useState,
} from 'react';
import { useLoaderData } from 'react-router-dom';

import Location from '@r6digital/rapidstor-types/react/entities/Location';

import { MapContext } from '@/features/rapidstor/providers/MapProvider';

import classes from './styles.module.scss';

export default function Map() {
    const location = useLoaderData() as Location;
    const mapIframeRef = useRef<HTMLIFrameElement>(null);
    const { firstAvailableUnit } = useContext(MapContext);

    const [mapUrl, setMapUrl] = useState<string>('');
    const [mapInitialised, setMapInitialised] = useState<boolean>(false);

    const updateUnits = (newUnit: string) => {
        const highlightUnitsMessage = {
            event: 'HIGHLIGHT_UNITS',
            payload: [newUnit],
        };

        const unitColorMessage = {
            event: 'UNIT_COLOR',
            payload: {
                '#b51f24': [newUnit],
            },
        };

        mapIframeRef.current?.contentWindow?.postMessage(
            highlightUnitsMessage,
            '*',
        );
        mapIframeRef.current?.contentWindow?.postMessage(unitColorMessage, '*');
    };

    useEffect(() => {
        if (mapInitialised) {
            return;
        }

        if (!firstAvailableUnit) {
            return;
        }
        const base = 'https://storapp-map.pages.dev/';
        const path = `${location.corpCode}/${location.locationCode}?`;
        const params = [
            // 'disablePan=true',
            'hideFloorSelector=true',
            'disableCameraRotation=true',
            'enableBuildingFloorLabel=true',
            // 'hideTouchToExplore=true',
            'zoomToSelection=true',
            'hideFindMyUnit=true',
            // 'disableZoom=true',
            'disableLogging=true',
            // 'hideSelectedUnitLabel=true',
        ];
        setMapInitialised(true);
        setMapUrl(
            `${base
        + path
        + params.join('&')
            }&highlightedUnits=${firstAvailableUnit}&unitColor={%27#b51f24': ['${firstAvailableUnit}']}`,
        );
    }, [firstAvailableUnit, mapInitialised, location]);

    useEffect(() => {
        updateUnits(firstAvailableUnit);
    }, [firstAvailableUnit]);

    if (mapInitialised) {
        return (
            <iframe
                ref={mapIframeRef}
                className={classes.map}
                src={mapUrl}
                title="Map"
            />
        );
    }
    return null;
}
